<!-- confirm-dialog.component.html -->
<div
  class="modal fade"
  id="confirmModal"
  tabindex="-1"
  aria-labelledby="confirmModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="confirmModalLabel">{{ 'store.confirm.deleteTitle' | translate }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" [attr.aria-label]="'common.close' | translate"></button>
      </div>
      <div class="modal-body">
        {{ 'store.confirm.deleteBody' | translate }} <strong>{{ itemName }}</strong>?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          {{ 'common.cancel' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="confirmDelete()"
          data-bs-dismiss="modal"
        >
          {{ 'common.delete' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
